function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 15,
  viewBox: "0 0 9 15",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#272F38",
  fillRule: "nonzero",
  d: "m9 7.071-.78-.755L1.685 0 0 1.51l5.754 5.561L0 12.631l1.685 1.512L8.22 7.827z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-angle-right.svg";
export { SvgComponent as ReactComponent };